<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Listagem de Posições de estoque
      </p>
    </div>

    <section class="row">
      <div class="q-mt-sm col-md-2">
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-input dense outlined label="Nome da Posição" v-model="name" />
      </div>
      <div class="q-mt-sm q-ml-sm">
        <q-btn
          no-caps
          icon="add"
          @click="criar"
          color="positive"
          label="Criar"
          class="q-ml-sm"
        />
      </div>
    </section>

    <div class="q-pt-md q-mt-lg">
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        title="Todas as posições de estoque"
        :rows="filteredRows"
        dense
        class="tabela-tamanho-fixo"
        :columns="columns"
        :loading="disable"
        hide-pagination
        v-model:pagination="pagination"
      >
        <template v-slot:top>
          <div class="text-h6 text-brand-5 text-weight-bold">
            Todas as posições de estoque
          </div>

          <q-space />
          <div class="col-md-3 col-sm-12 col-xs-12" style="width: 250px">
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              v-model="filter"
              placeholder="Pesquisar"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </template>

        <template #body-cell-delete="props">
          <q-td align="center">
            <q-btn
              @click="abrirModalDeletar(props.row.id)"
              color="negative"
              flat
              round
              icon="delete"
            />
          </q-td>
        </template>
      </q-table>

      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="true"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <DialogConfirmDesign
      :mensagem="modalDeletar.mensagem"
      :exibir="modalDeletar.exibir"
      :titulo="modalDeletar.titulo"
      @resultado="confirmarDeletar"
    />
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    field: "nome",
    align: "left",
  },
  {
    name: "delete",
    label: "Deletar",
    field: "delete",
    align: "center",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogConfirmDesign from "../../../../components/DialogConfirmDesign.vue";

export default {
  components: {
    ListaUnidadesSelect,
    DialogConfirmDesign,
  },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const name = ref();
    const rows = ref([]);
    const disable = ref(true);
    const unidade = ref();
    const filter = ref("");
    const pagination = ref({
      page: 1,
      rowsPerPage: 50,
    });

    const modalDeletar = ref({
      exibir: false,
      mensagem: "",
      titulo: "Confirmar Exclusão",
      posicaoId: null,
    });

    const getDados = async () => {
      try {
        const response = await store.dispatch("estoque/listarPosicoes", {
          vendor_id: store.state.org.unidadeData.id,
        });

        rows.value = response.data.data;
        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const criar = async () => {
      try {
        await store.dispatch("estoque/criarPosicao", {
          vendor_id: store.state.org.unidadeData.id,
          nome: name.value,
        });

        $q.notify({
          message: "Criado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const abrirModalDeletar = (id) => {
      modalDeletar.value.posicaoId = id;
      modalDeletar.value.mensagem =
        "Tem certeza que deseja deletar essa Posição de estoque?";
      modalDeletar.value.exibir = true;
    };

    const confirmarDeletar = async (confirmado) => {
      modalDeletar.value.exibir = false;

      if (!confirmado) {
        modalDeletar.value.posicaoId = null;
        return;
      }

      const id = modalDeletar.value.posicaoId;

      try {
        await store.dispatch("estoque/deletarPosicao", {
          id: id,
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro ao deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }

      modalDeletar.value.posicaoId = null;
    };

    const deleteId = async (id) => {
      try {
        await store.dispatch("estoque/deletarPosicao", {
          id: id,
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const pagesNumber = computed(() => {
      return Math.ceil(
        filteredRows.value.length / pagination.value.rowsPerPage
      );
    });

    const filteredRows = computed(() => {
      const search = filter.value.trim().toLowerCase();

      if (!search) {
        return rows.value;
      }

      return rows.value.filter((row) => {
        const nome = String(row?.nome ?? "").toLowerCase();
        return nome.includes(search);
      });
    });

    watch(filter, () => {
      pagination.value.page = 1;
    });

    return {
      criar,
      name,
      rows,
      disable,
      columns,
      getDados,
      deleteId,
      abrirModalDeletar,
      confirmarDeletar,
      modalDeletar,
      unidade,
      filter,
      pagination,
      filteredRows,
      pagesNumber,
    };
  },
};
</script>

<style></style>
